module.exports = __webpack_public_path__ + "img/letter.0cf05b89.png";